import React, { useState } from "react";
import { toast } from "react-toastify";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";
import { addWestoriesdetail } from "service/api";
import DatatableTables from "./DatatableTables";
import AdminGuard from "helpers/AuthType/AdminGuard";

const Addwebstories = () => {
    const [webstories, setWebstories] = useState({ title: '', url: '', keywords: '', description: [], urls: [] });
    const [rows1, setRows1] = useState([{ id: 1 }]);
    const [images, setImages] = useState([]);
    const [refreshTable, setRefreshTable] = useState(false);

    // Add new row
    function handleAddRowNested() {
        setRows1([...rows1, { id: rows1.length + 1 }]);
    }

    // Remove row
    function handleRemoveRow(id) {
        if (rows1.length > 1) {
            setRows1(rows1.filter(row => row.id !== id));
        }
    }

    // Handle text input changes
    const onValueChange = (e, index) => {
        const updatedDescriptions = [...webstories.description];
        const updatedUrls = [...webstories.urls];
        updatedDescriptions[index] = e.target.value;
        updatedUrls[index] = e.target.value;
        setWebstories({ ...webstories, description: updatedDescriptions });
        setWebstories({ ...webstories, urls: updatedUrls });
    };

    // Handle file input
    const onFileChange = (e, index) => {
        const updatedImages = [...images];
        updatedImages[index] = e.target.files[0];
        setImages(updatedImages);
    };

    // Form submission
    const addWestories = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("title", webstories.title);
        formData.append("url", webstories.url);
        formData.append("keywords", webstories.keywords);
        formData.append("views", "0");

        // Append descriptions properly
        webstories.description.forEach((desc) => {
            formData.append("description[]", desc);
        });
        webstories.urls.forEach((urlss) => {
            formData.append("urls[]", urlss);
        });

        // Append images as an array
        images.forEach((img) => {
            if (img instanceof File) {
                formData.append("img", img);
            }
        });

        console.log("Sending FormData:", Object.fromEntries(formData.entries()));

        try {
            await addWestoriesdetail(formData);
            toast.success("Web story added successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setRefreshTable(prevState => !prevState);
        } catch (error) {
            toast.error("Failed to add web story. Please try again.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };


    return (
        <AdminGuard>
            <React.Fragment>
                <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                    <Container fluid={true} className="py-1">
                        <Row className="justify-content-center">
                            <Col xl={6} lg={6} md={12}>
                                <Card style={{ background: "rgba(255, 255, 255, 0.1)", border: "none", borderRadius: "15px" }}>
                                    <CardBody>
                                        <CardTitle className="mb-4 text-center" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                                            Add Web-Stories
                                        </CardTitle>
                                        <Form encType="multipart/form-data">
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">Title</Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="title"
                                                            name="title"
                                                            onChange={(e) => setWebstories({ ...webstories, title: e.target.value })}
                                                            placeholder="Title you want to display in URL"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>
                                                {/* <Col md={12}>
                                                <div className="mb-3">
                                                    <Label htmlFor="title">URL</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="url"
                                                        name="url"
                                                        onChange={(e) => setWebstories({ ...webstories, url: e.target.value })}
                                                        placeholder="Read more URL"
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>
                                            </Col> */}
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="title">keywords To search</Label>
                                                        <Input
                                                            type="textarea"
                                                            className="form-control"
                                                            id="keywords"
                                                            name="keywords"
                                                            onChange={(e) => setWebstories({ ...webstories, keywords: e.target.value })}
                                                            placeholder="keywords you want to search"
                                                            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        />
                                                    </div>
                                                </Col>
                                                <div className="inner-repeater mb-4">
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            {rows1.map((formRow, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <Row className="mb-2">
                                                                            <Col md="6">
                                                                                <Label>Description</Label>
                                                                                <Input
                                                                                    type="textarea"
                                                                                    name={`description-${index}`}
                                                                                    onChange={(e) => onValueChange(e, index)}
                                                                                    className="inner form-control"
                                                                                    placeholder="Enter description..."
                                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="6">
                                                                                <Label>url</Label>
                                                                                <Input
                                                                                    type="text"
                                                                                    name={`urls-${index}`}
                                                                                    onChange={(e) => onValueChange(e, index)}
                                                                                    className="inner form-control"
                                                                                    placeholder="Enter urls..."
                                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="6">
                                                                                <Label>Upload Image</Label>
                                                                                <Input
                                                                                    type="file"
                                                                                    name={`img-${index}`}
                                                                                    onChange={(e) => onFileChange(e, index)}
                                                                                    className="inner form-control"
                                                                                    style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                                                />
                                                                            </Col>
                                                                            <Col md="2 py-4">
                                                                                {index !== 0 && (
                                                                                    <Button
                                                                                        color="danger"
                                                                                        className="btn-block inner"
                                                                                        style={{ width: "100%" }}
                                                                                        onClick={() => handleRemoveRow(formRow.id)}
                                                                                    >
                                                                                        Delete
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <Button onClick={handleAddRowNested} color="success" className="mt-1">
                                                        Add More
                                                    </Button>
                                                </div>
                                            </Row>

                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    onClick={addWestories}
                                                    style={{
                                                        width: "100%",
                                                        fontWeight: "600",
                                                        background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                        border: "none",
                                                        padding: "10px 20px",
                                                        borderRadius: "25px",
                                                    }}
                                                >
                                                    Send
                                                </button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-1"></CardTitle>
                                    <DatatableTables key={refreshTable} />
                                </CardBody>
                            </Card>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    );
};

export default Addwebstories;
